import React, { useRef } from "react";
import { Alert, Table } from "react-bootstrap";
import { Checkbox, Input, Modal } from "antd";
import {
  // convertDateWithTime,
  formatDate,
  getDateToday,
} from "../../Helpers/Utils/Common";
import { Space, Row, Col } from "antd";
// import { useReactToPrint } from "react-to-print";
import BtnPrint from "../../Components/Commons/Buttons/BtnPrint";
import FormHeader from "../../Components/Commons/FormHeader";
import FormFooter from "../../Components/Commons/Table/FormFooter";
import { formatDateMMMMDYYYY } from "../../Components/Helpers/Utilities/Common";
// import html2canvas from 'html2canvas';
// import jsPDF from "jspdf";

export default function PrintXrayDiagnostics({
  show,
  onHide,
  diagnostics,
  assessmentId,
  patient,
  printDiagnostics, //these are the diagnostic items from xray
  isNew,
}) {
  const componentRef = useRef();
  if (
    !diagnostics ||
    (Array.isArray(diagnostics) && diagnostics.length === 0) ||
    (typeof diagnostics === "object" && Object.keys(diagnostics).length === 0)
  ) {
    return (
      <Modal
        // title="Print Diagnostic"
        open={show}
        onOk={onHide}
        okText="Okay"
        cancelText="Close"
        onCancel={onHide}
        className="ant-rx"
      >
        <Alert variant="warning" className="gotham">
          No therapeutics found for printing. Please add therapeutic details to
          the patient's assessment before attempting to print.
        </Alert>
      </Modal>
    );
  } else {
    return (
      <Modal
        // title="Print Diagnostic"
        open={show}
        // onOk={() => handlePrint(`diagnotsics_${assessmentId}`)}
        // okText="Print"
        cancelText="Close"
        onCancel={onHide}
        className="center"
        footer={null}
      >
        <Row
          id={`diagnotsics_${assessmentId}`}
          ref={componentRef}
          className="rx-container"
        >
          <Col span={24} className="px-4">
            <Row className="rx-header">
              <Col span={24}>
                <FormHeader />
                <Row className="mt-3">
                  <Col span={24} align="center">
                    <h5>
                      <strong>X-RAY REQUEST FORM</strong>
                    </h5>
                  </Col>
                </Row>
                <Row className="mt-3 ps-3">
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Case Number:</div>
                      <strong>{diagnostics?.case_number}</strong>
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Date:</div>
                      <strong>
                        {patient.is_sunday_patient === "0"
                          ? formatDateMMMMDYYYY(diagnostics.diagnostic_date)
                          : formatDateMMMMDYYYY(patient.last_checkup_date)}
                      </strong>
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Age:</div>
                      <strong>{patient?.age}</strong>
                    </Space>
                  </Col>
                </Row>
                <Row className="mt-1 ps-3">
                  <Col span={16} align="left">
                    <Space className="form-info">
                      <div>Patient Name:</div>
                      <strong>{patient?.formatted_patient_name}</strong>
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Sex:</div>
                      <strong>{patient?.patient_sex?.toUpperCase()}</strong>
                    </Space>
                  </Col>
                </Row>
                <Row className="mt-1 ps-3">
                  <Col span={16} align="left">
                    <Space className="form-info">
                      <div>Address:</div>
                      <strong>{patient?.patient_address}</strong>
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Date of Birth:</div>
                      <strong>{formatDateMMMMDYYYY(patient?.birthdate)}</strong>
                    </Space>
                  </Col>
                </Row>
                <Row className="mt-1 ps-3">
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Room Number:</div>
                      <strong>{diagnostics?.room_number}</strong>
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>PhilHealth Member:</div>
                      <Checkbox
                        style={{
                          pointerEvents: "none",
                          cursor: "default",
                        }}
                        className="readonly-checkbox"
                        value={diagnostics.is_philhealth_member}
                        checked={diagnostics.is_philhealth_member === "1"}
                      />
                    </Space>
                  </Col>
                  <Col span={8} align="left">
                    <Space className="form-info">
                      <div>Non Member:</div>
                      <Checkbox
                        style={{
                          pointerEvents: "none",
                          cursor: "default",
                        }}
                        className="readonly-checkbox"
                        value={diagnostics.is_philhealth_member}
                        checked={diagnostics.is_philhealth_member === "0"}
                      />
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* {(patient?.hmo_type !== "" && patient?.hmo_type !== null) &&(
              <>
                <Row 
                  className="mt-1"
                >
                  <Col span={24} className="px-3">
                    <Space 
                      className="form-info"
                      style={{
                        backgroundColor: "#273DE9", 
                        padding: "2px 3px",
                        borderRadius: "3px",
                        color: "white"
                      }}
                    >
                      <div>
                      Insurance: 
                      </div>
                      <strong>
                        {patient?.hmo_type}
                      </strong>
                    </Space>
                  </Col>
                </Row>
                <Row 
                  className="rx-content mt-4"
                >
                  <Col span={4} className="px-3">
                    <Space 
                      className="form-info"
                    >
                      <div>
                      Diagnosis: 
                      </div>
                    </Space>
                  </Col>
                  <Col span={20} className="px-3">
                    <Space 
                      className="form-info"
                    >
                      <strong>
                        {patient?.formatted_diagnosis}
                      </strong>
                    </Space>
                  </Col>
                </Row>
              </>
            )}
            {(patient?.corporate_type !== "" && patient?.corporate_type !== null) &&(
              <>
                <Row 
                  className="mt-1"
                >
                  <Col span={24} className="px-3">
                    <Space 
                      className="form-info"
                      style={{
                        backgroundColor: patient.corporate_type?.toLowerCase() === 'gmc-mg' ? '#fa8c16' : '#fadb14',
                        padding: "2px 3px",
                        borderRadius: "3px",
                        color: patient.corporate_type?.toLowerCase() === 'gmc-mg' ? 'white' : 'black'
                      }}
                    >
                      <div>
                      Corporate: 
                      </div>
                      <strong>
                        {patient?.corporate_type}
                      </strong>
                    </Space>
                  </Col>
                </Row>
                <Row 
                  className="rx-content mt-4"
                >
                  <Col span={4} className="px-3">
                    <Space 
                      className="form-info"
                    >
                      <div>
                      Diagnosis: 
                      </div>
                    </Space>
                  </Col>
                  <Col span={20} className="px-3">
                    <Space 
                      className="form-info"
                    >
                      <strong>
                        {patient?.formatted_diagnosis}
                      </strong>
                    </Space>
                  </Col>
                </Row>
              </>
            )} */}
            <Row className="rx-content mt-3">
              <Col span={24} className="px-3">
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: "235px" }}>Examination Desired</td>
                      <td>
                        {printDiagnostics?.xray?.length > 0 ? (
                          <ul>
                            {(isNew === "1" || isNew === "0"
                              ? printDiagnostics.xray.filter(
                                  (test) => test.is_new === isNew
                                )
                              : printDiagnostics.xray
                            ).map((test, index) => (
                              <li key={index}>{test.lab_test_name}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="m-0 p-0 text-muted">
                            No diagnostic tests added.
                          </p>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="ps-3">
              <Col span={5} align="left">
                <Space className="form-info">
                  <div>Fasting:</div>
                </Space>
              </Col>
              <Col span={19} align="left">
                <strong>{diagnostics?.fasting || "N/A"}</strong>
              </Col>
            </Row>
            <Row className="ps-3">
              <Col span={5} align="left">
                <Space className="form-info">
                  <div>Notes:</div>
                </Space>
              </Col>
              <Col span={19} align="left">
                <strong>{diagnostics?.notes || ""}</strong>
              </Col>
            </Row>
            <Row className="ps-3">
              <Col span={5} align="left">
                <Space className="form-info">
                  <div>Chief Complaint:</div>
                </Space>
              </Col>
              <Col span={19} align="left">
                <strong>{diagnostics.chief_complaint}</strong>
              </Col>
            </Row>
            <Row className="ps-3">
              <Col span={5} align="left">
                <Space className="form-info">
                  <div>Attending Physician:</div>
                </Space>
              </Col>
              <Col span={19} align="left">
                <strong>{diagnostics.doctor_name}</strong>
              </Col>
            </Row>
            {/* <FormFooter
              patient={patient}
            /> */}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col span={16}></Col>
          <Col span={8}>
            <BtnPrint
              label={"Print"}
              size={"xl"}
              // divId={`diagnotsics_${assessmentId}`}
              divId={componentRef}
              fileName={`xray_diagnotsics_${patient?.patient_name}.pdf`}
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}
